//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import CHART from '../library/chart'
import WILAYAH from  '../library/getWilayah'
import UMUM from  '../library/umum.js'
import FETCHING from  '../library/fetching'
import { setTimeout, setInterval } from 'timers';
import { timeout } from 'q';

export default {
  data() {
    return {
      alert: false,
      simpan1: false,


      jml_penduduk : 0,
      jml_pria : 0,
      jml_wanita : 0,


      cek_load_data : true,



      list_desa : [],
      list_kecamatan : [],

      filter : {
        des_kel : '',
        kecamatan : '',
      },

      WILAYAH : WILAYAH,


    }
  },
  methods: {


  
    JenisKelamin : async function(){
      // // var body = this.form 
      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "jk"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);

      this.jml_pria = dataArray[0].y
      this.jml_wanita = dataArray[1].y
      this.jml_penduduk = this.jml_pria + this.jml_wanita

      const data = await dataArray
      await CHART.PieChart('JenisKelamin', 'Jumlah Berdasarkan Jenis Kelamin (%)', data)


    },

    statusPerkawinan : async function(){
      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "status_kawin"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);
      let kategori = dataArray.name
      let data = dataArray.y
      await CHART.BarChart3D('statusPerkawinan', 'Status Perkawinan', kategori, data)

    },

    piramidaKependudukan : async function(){
      let jns1 = 'Age (Pria)';
      let jns2 =  'Age (Wanita)';


      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "piramida"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);

      let kategori = dataArray.uraian;

      let dataPria = dataArray.pria;
      let dataWanita = dataArray.wanita;


      await CHART.BarRace('piramidaKependudukan', 'Piramida Kependudukan', jns1, jns2, kategori, dataPria, dataWanita)

    },



    statusPendidikan : async function(){
      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "status_pendidikan"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);

      let kategori = dataArray.name
      let data = dataArray.y

      await CHART.BarChart3D('statusPendidikan', 'Jenjang Pendidikan', kategori, data)

    },

    statusPekerjaan : async function(){
      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "status_pekerjaan"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);

      // console.log(dataArray);
      const data = dataArray
 
      await CHART.PieChart('statusPekerjaan', 'Jenis Pekerjaan (%)', data)

    },

    statusAgama : async function(){

      var body = this.filter
      var URLX = this.$store.state.url.URL_DASHBOARD + "status_agama"
      var dataArray = await FETCHING.FETCH_POST(URLX, body);

      // console.log(dataArray);
      const data = dataArray

      
      await CHART.PieChart('statusAgama', 'Agama (%)', data)
      
    },



    getKecamatan : async function() {

      // console.log('========== APUKA ==========');

      this.list_kecamatan = await WILAYAH.getKec('');
      this.filter.des_kel = '';
      this.list_desa = await WILAYAH.postDesKel(this.filter.kecamatan);
      this.getChartAll();
    },
    
    
    
    async getChartAll () {
      this.$store.commit('shoWLoading')
      this.JenisKelamin()
      this.$store.commit('hideLoading')
      this.statusPerkawinan();
      this.piramidaKependudukan();
      this.statusPekerjaan();
      this.statusPendidikan();
      this.statusAgama();
    }

  






  },

  mounted () {


    this.getKecamatan();

    // this.getChartAll();

     


  },
}
